import React from "react";

const UserProfile = ({
  username,
  isOnline,
  isInactive,
  postCount,
  registrationDate,
  profileImage,
}) => {
  let statusDot =
    "https://cdn.builder.io/api/v1/image/assets/TEMP/e454098988e46d3b5f9dd7d016f09c0659017f00d78c310943858b4c500b4aa6?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0"; // Default offline
  let statusText = "Offline";

  if (isOnline) {
    statusDot =
      "https://cdn.builder.io/api/v1/image/assets/TEMP/e454098988e46d3b5f9dd7d016f09c0659017f00d78c310943858b4c500b4aa6?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0";
    statusText = "On-line";
  } else if (isInactive) {
    statusDot =
      "https://cdn.builder.io/api/v1/image/assets/TEMP/e7b3bfe4aa03ccf571b77a138d481c5f9d9290fb7316bc9d1a6dc80e3076e51f?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0";
    statusText = "Inactive";
  } else {
    statusDot =
      "https://cdn.builder.io/api/v1/image/assets/TEMP/f41662668e0072097ed79395179e3a45b8694e56330f6fad31067bc66b973661?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0";
    statusText = "Offline";
  }

  return (
    <aside className="p-3 w-64 bg-gray-100 rounded-xl min-w-60">
      <div className="flex gap-2 items-center w-full">
        {profileImage ? (
          <img
            src={profileImage}
            alt={`${username}'s profile`}
            className="object-contain shrink-0 self-stretch my-auto w-10 aspect-square rounded-[400px]"
          />
        ) : (
          <div className="flex shrink-0 self-stretch my-auto w-10 h-10 bg-white rounded-[400px]" />
        )}
        <div className="flex flex-col flex-1 shrink justify-center self-stretch my-auto basis-0">
          <h3 className="text-base font-medium leading-loose text-blue-500">
            {username}
          </h3>
          <div className="flex gap-0.5 items-center w-full">
            <div className="flex gap-2 justify-center items-center self-stretch p-1 my-auto w-4">
              <img
                src={statusDot}
                alt="Status indicator"
                className="object-contain self-stretch my-auto w-2 aspect-square"
              />
            </div>
            <span className="flex-1 shrink self-stretch my-auto text-xs font-medium text-gray-400 basis-0">
              {statusText}
            </span>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start mt-4 w-full text-sm leading-loose">
        <div className="flex gap-1 items-center whitespace-nowrap">
          <span className="self-stretch my-auto text-gray-400">Posts:</span>
          <span className="self-stretch my-auto font-semibold text-blue-500">
            {postCount}
          </span>
        </div>
        <div className="flex gap-1 items-center mt-1.5 text-gray-400">
          <span className="self-stretch my-auto">Registered:</span>
          <span className="self-stretch my-auto">{registrationDate}</span>
        </div>
        <div className="flex gap-1 items-center mt-1.5 text-gray-400">
          <span className="self-stretch my-auto">Contact details:</span>
          <button
            aria-label="Send message"
            className="flex shrink-0 self-stretch my-auto h-[22px] w-[22px]"
          />
        </div>
      </div>
    </aside>
  );
};

export default UserProfile;
